<template>
  <!-- Change viewBox and fill params -->
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 16 32"
  >
    <g>
      <path
        fill="#4365e2"
        d="M11 6h5v-6h-5c-3.845 0.052-6.948 3.155-7 6.995l-0 0.005v3h-4v6h4v16h6v-16h5l1-6h-6v-3c-0.001-0.017-0.002-0.037-0.002-0.057 0-0.522 0.423-0.945 0.945-0.945 0.020 0 0.040 0.001 0.059 0.002l-0.003-0z"
      />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      default: ''
    },
    height: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: ''
    }
  }
}
</script>
